<template>
    <div class='payOrders'>
        <div class="planlist">
            <el-row style="margin-bottom:1rem">
                <el-col :span="24" style="text-align:left">
                    <el-input style="width:200px;" v-model="paginationInfo.condition.search_key"
                        placeholder="请输入手机号/商户单号" clearable></el-input>
                    <el-date-picker v-model="create_date[0]" align="right" type="date" placeholder="选择开始时间"
                        :picker-options="{
                            disabledDate(time) {
                                return time.getTime() > Date.now();
                            },
                        }">
                    </el-date-picker>
                    <el-date-picker v-model="create_date[1]" align="right" type="date" placeholder="选择结束时间"
                        :picker-options="{
                            disabledDate(time) {
                                return time.getTime() > Date.now();
                            },
                        }">
                    </el-date-picker>
                    <el-select v-model="paginationInfo.condition.trade_status" placeholder="请选择订单状态" @change="queryList"
                        filterable clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option label="预创建" value="PRE_CREATE"></el-option>
                        <el-option label="支付成功" value="TRADE_SUCCESS"></el-option>
                        <el-option label="交易关闭" value="TRADE_CLOSED"></el-option>
                        <el-option label="交易完结" value="TRADE_FINISHED"></el-option>
                        <el-option label="交易创建" value="WAIT_BUYER_PAY"></el-option>
                    </el-select>
                    <el-select v-model="paginationInfo.condition.account_channel" placeholder="请选择办理账号"
                        @change="queryList" filterable clearable>
                        <el-option v-for="item in accountChannelList" :key="item.dictdata_value"
                            :label="item.dictdata_name" :value="item.dictdata_value"></el-option>
                    </el-select>
                    <el-button @click="queryList">查询</el-button>
                </el-col>
            </el-row>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form>
                            <el-form-item label="IP:">
                                <span>{{ props.row.ip }}</span>
                            </el-form-item>
                            <el-form-item label="auth_no:">
                                <span>{{ props.row.auth_no }}</span>
                            </el-form-item>
                            <el-form-item label="user_agent:">
                                <span>{{ props.row.http_user_agent }}</span>
                            </el-form-item>
                            <el-form-item v-if="props.row.refund" label="refund_status:">
                                <span>{{
                                    props.row.refund.refund_status == 'REFUND_SUCCESS' ? '退款成功' :
                                        rops.row.refund.refund_status
                                }}</span>
                            </el-form-item>
                            <el-form-item v-if="props.row.refund" label="refund_amount:">
                                <span>{{ props.row.refund.refund_amount }}</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="out_trade_no" label="订单号" align='center' width="150">
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" align='center' width="150">
                </el-table-column>
                <el-table-column label="创建时间" align='center' width="300">
                    <template slot-scope="scope">{{ $moment(scope.row.create_date).format('YYYY-MM-DD HH:mm:ss')
                        }}</template>
                </el-table-column>
                <el-table-column prop="subject" label="subject" align='center'>
                </el-table-column>
                <el-table-column label="支付价格" align='center'>
                    <template slot-scope="scope">{{ scope.row.total_amount }}元</template>
                </el-table-column>
                <el-table-column label="办理账号" align='center'>
                    <template slot-scope="scope">
                        {{ getAccountChannelName(scope.row.account_channel) }}
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" align='center'>
                    <template slot-scope="scope">
                        <span v-if="scope.row.trade_status == 'TRADE_SUCCESS'">支付成功</span>
                        <span v-else-if="scope.row.trade_status == 'PRE_CREATE'">预创建</span>
                        <span v-else-if="scope.row.trade_status == 'TRADE_CLOSED'">交易关闭</span>
                        <span v-else-if="scope.row.trade_status == 'TRADE_FINISHED'">交易完结</span>
                        <span v-else-if="scope.row.trade_status == 'WAIT_BUYER_PAY'">交易创建</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align='center'>
                    <template slot-scope="scope">
                        <el-button type="primary" @click="alipayManagerOrdersSynctrade(scope.row._id)"
                            plain>同步</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="paginationInfo.pageNo" :page-sizes="[10, 20, 50, 100]"
                :page-size="paginationInfo.pageSize" :total="paginationInfo.total"
                layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            orderDoctData: [],
            dictData: [],
            accountChannelList: [],
            create_date: [new Date(), new Date()],
            paginationInfo: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
                condition: {
                    out_trade_no: '',
                    account_channel: 'jybbs',
                    create_date: '',
                    trade_status: '',
                    biz_type: 'EQUITY_MEMBER',
                    channel_code: ''
                }
            },
            tableData: [],
            formData: {
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getAccountChannel();
        this.queryList();
    },
    mounted() {
    },
    methods: {
        alipayManagerOrdersSynctrade(id) {
            window.console.log(123123)
            window.console.log(id)
            this.$confirm('是否同步此条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$service.OnlineOrderService.alipayManagerOrdersSynctrade({ id }).then(res => {
                    if (res.data.code === 0) {
                        this.getManagerTradesAL();
                        this.$message({
                            message: '同步成功！',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    window.console.log(err)
                    this.$message({
                        message: '网络错误，请重新修改！',
                        type: 'error'
                    });
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        getAccountChannelName(str) {
            let name = "无";
            this.accountChannelList.forEach(item => {
                if (item.dictdata_value == str) {
                    name = item.dictdata_name;
                }
            });
            return name;
        },
        getDictName(str) {
            let name = "无";
            this.dictData.forEach(item => {
                if (item.dictdata_value == str) {
                    name = item.dictdata_name;
                }
            });
            return name;
        },
        getAccountChannel() {
            this.accountChannelList = [
                {
                    "_id": "65f93d26676aaa63fcf1f5c1",
                    "dictdata_name": "爸比说",
                    "dictdata_value": "jybbs",
                    "isfixed": false
                },
                {
                    "_id": "65f93d26676aaa63fcf1f5d5",
                    "dictdata_name": "激风文化",
                    "dictdata_value": "jfwh",
                    "isfixed": false
                }
            ]
        },
        queryList() {
            if (this.create_date.length >= 2 && this.create_date[0] && this.create_date[1]) {
                this.paginationInfo.condition.create_date = [this.create_date[0], this.create_date[1]];
            } else {
                this.paginationInfo.condition.create_date = null;
            }
            this.paginationInfo.pageNo = 1;
            this.getManagerTradesAL()
        },
        handleSizeChange(val) {
            window.console.log(`每页 ${val} 条`);
            this.paginationInfo.pageSize = val;
            this.paginationInfo.pageNo = 1;
            this.getManagerTradesAL();
        },
        handleCurrentChange(val) {
            window.console.log(`当前页: ${val}`);
            this.paginationInfo.pageNo = val;
            this.getManagerTradesAL();
        },
        getManagerTradesAL() {
            this.$service.OnlineOrderService
                .getManagerTradesAL(this.paginationInfo)
                .then(res => {
                    if (res.data.code === 0) {
                        let dataInfo = res.data.data
                        this.paginationInfo.total = dataInfo.total;
                        this.tableData = dataInfo.trades;
                    }
                })
        },
    }
}
</script>
<style lang='less' scoped>
.payOrders {
    ::v-deep .el-form-item__label {
        font-weight: bold;
    }
}
</style>